<template>
  <div class="matches-page" :key="this.$route.path + isActive('page', 'main') + isActive('page', 'sports') + isActive('page', 'upcoming') + $i18n.locale">
    <m-scrollbar
      :key="this.$route.path + isActive('page', 'main') + isActive('page', 'sports') + isActive('page', 'upcoming') + $i18n.locale"
      id="home-overview-scrollbar"
    >
      <main-page :key="this.$route.path + isActive('page', 'main') + isActive('page', 'sports') + isActive('page', 'upcoming') + $i18n.locale"/>
    </m-scrollbar>
    <!--m-loader
      :top="isTopLoader()"
      v-if="isLoaderVisible()" / -->
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import MLoader from '@/components/sports/matches/Loader'
import MainPage from '@/components/sports/main/Main'
import { mapState } from 'vuex'

export default {
  components: {
    MScrollbar,
    MLoader,
    MainPage
  },
  data () {
    return {
      scrollTop: 0,
      clientHeight: 0
    }
  },
  computed: {
    ...mapState({
      liveLoading: state => state.live.loader.loading,
      liveScrollLoading: state => state.live.loader.scrollLoading,
      liveIsTopLoader: state => state.live.loader.top,
      liveScreenTop: state => state.live.screen.top,
      liveScreenBottom: state => state.live.screen.bottom,

      prematchLoading: state => state.prematch.loader.loading,
      prematchScrollLoading: state => state.prematch.loader.scrollLoading,
      prematchIsTopLoader: state => state.prematch.loader.top,
      prematchScreenTop: state => state.prematch.screen.top,
      prematchScreenBottom: state => state.prematch.screen.bottom
    })
  },
  // watch: {
  //   '$i18n.locale' (to, from) {
  //     let view = document.querySelector('#home-overview-scrollbar')
  //     if (this.isActive('section', 'live')) {
  //       this.$store.dispatch('live/GET_MENU_SPORTS')
  //       this.$store.dispatch('live/GET_OVERVIEW', {
  //         params: Object.assign({
  //           top: view.scrollTop,
  //           height: view.clientHeight
  //         }, this.$route.params),
  //         loader: false
  //       })
  //     } else if (this.isActive('section', 'popular')) {
  //       this.$store.dispatch('prematch/GET_POPULAR_MATCHES', {
  //         params: Object.assign({
  //           top: view.scrollTop,
  //           height: view.clientHeight
  //         }, this.$route.params),
  //         loader: false
  //       })
  //     }
  //   }
  // },
  mounted () {
    let view = document.querySelector('#home-overview-scrollbar')
    view.scrollTop = 0
    this.clientHeight = view.clientHeight
  },
  methods: {
    scrollY (event, up) {
      if (this.isActive('section', 'live')) {
        this.$store.commit('live/SET_LOADER_POSITION', up ? 'top' : 'bottom')
        let view = document.querySelector('#home-overview-scrollbar')
        this.scrollTop = view.scrollTop
        let doit = () => {
          this.scrollTop = view.scrollTop
          this.$store.dispatch('live/GET_OVERVIEW', {
            params: Object.assign({
              top: this.scrollTop,
              height: view.clientHeight
            }, this.$route.params),
            scroll: true
          })
        }
        setTimeout(function () { doit() }, 100)
      } else if (this.isActive('section', 'popular')) {
        this.$store.commit('prematch/SET_LOADER_POSITION', up ? 'top' : 'bottom')
        let view = document.querySelector('#home-overview-scrollbar')
        this.scrollTop = view.scrollTop
        let doit = () => {
          this.scrollTop = view.scrollTop
          this.$store.dispatch('prematch/GET_POPULAR_MATCHES', {
            params: Object.assign({
              top: this.scrollTop,
              height: view.clientHeight
            }, this.$route.params),
            scroll: true
          })
        }
        setTimeout(function () { doit() }, 100)
      }
    },
    isTopLoader () {
      return (this.isActive('section', 'live') && this.liveIsTopLoader) ||
        (this.isActive('section', 'popular') && this.prematchIsTopLoader)
    },
    isLoaderVisible () {
      return (this.isActive('section', 'live') && (this.liveLoading || (this.liveScrollLoading && (this.liveScreenBottom < this.scrollTop + (this.clientHeight - 100) || this.liveScreenTop > this.scrollTop + 100)))) ||
        (this.isActive('section', 'popular') && (this.prematchLoading || (this.prematchScrollLoading && (this.prematchScreenBottom < this.scrollTop + (this.clientHeight - 100) || this.prematchScreenTop > this.scrollTop + 100))))
    }
  }
}
</script>

<style scoped>
.matches-page { height: 100%; overflow: hidden; position: relative; }

.top.overview-loader { top: -23px !important; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main/View.vue